import { headerHeight } from "../../../constants";
import styled from "styled-components";

export const StyledOuterWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const StyledWrapper = styled.div`
  height: ${headerHeight}px;
  display: block;
`;

export const StyledCanvas = styled.canvas``;
